export const dialogs = {
  edit_email: 'edit-email',
  confirm_email: 'confirm-email',
  edit_cellphone: 'edit-cellphone',
  confirm_cellphone: 'confirm-cellphone',
  edit_password: 'edit-password',
}

export const LOGIN_TYPE_ID = 3
export const MINIMUM_PASSWORD_LENGTH = 8
export const MAXIMUM_PASSWORD_LENGTH = 30
export const MAXIMUM_EMAIL_LENGTH = 79
export const MAXIMUM_CODE_LENGTH = 4

export const MESSAGES = {
  saving: 'Salvando, aguarde...',
  checking_mobile: 'Estamos validando o número, aguarde...',
  checking_code: 'Estamos validando o código, aguarde...',
  different_email: 'Os e-mails digitados estão diferentes',
  different_password: 'As senhas digitadas estão diferentes',
  checking_email: 'Estamos validando o e-mail, aguarde...',
  wrong_password: 'A senha atual está incorreta.',
}
